import { render, staticRenderFns } from "./TableDialog.vue?vue&type=template&id=55190b4c"
import script from "./TableDialog.vue?vue&type=script&lang=js"
export * from "./TableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports